import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useState, useEffect } from 'react';
import { canUseDOM } from '../../utils';
export function useMobileNav(isMobile) {
  var displayMobMenu = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mobileNavVisible = _useState2[0],
    setMobileNavVisible = _useState2[1];
  var _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    mobileNavActiveIndex = _useState4[0],
    setMobileNavActiveIndex = _useState4[1];
  useEffect(function () {
    if (typeof window === 'undefined') {
      return;
    }
    var html = document.querySelector('html');
    if (html) {
      if (typeof window !== 'undefined') {
        if (mobileNavVisible) {
          html.style.overflowY = "hidden";
        } else {
          html.style.overflowY = "inherit";
        }
      }
    }
  }, [mobileNavVisible]);
  var handleMobileNavToggleClick = function handleMobileNavToggleClick() {
    if (displayMobMenu || window.matchMedia("(max-width: ".concat(isMobile ? '1200px' : '991px', ")")).matches) {
      var happinessMeterWidget = canUseDOM ? document.querySelector('.happiness-meter-widget') : null;
      var htmlElement = canUseDOM ? document.querySelector('html') : null;
      if (htmlElement) {
        if (!mobileNavVisible) {
          htmlElement.classList.add('prevent-scroll');
        } else {
          htmlElement.classList.remove('prevent-scroll');
        }
      }
      if (happinessMeterWidget) {
        happinessMeterWidget.style.zIndex = mobileNavVisible ? 'inherit' : '0';
      }
      setMobileNavVisible(!mobileNavVisible);
    }
  };
  var handleMobileNavDropdownClick = function handleMobileNavDropdownClick(itemIndex) {
    if (displayMobMenu || window.matchMedia("(max-width: ".concat(isMobile ? '1200px' : '991px', ")")).matches) {
      // If the clicked itemIndex matches the active item index, then assume
      // the user is closing the active dropdown menu.

      var index = itemIndex !== mobileNavActiveIndex ? itemIndex : -1;
      setMobileNavActiveIndex(index);
    }
  };
  return {
    mobileNavVisible: mobileNavVisible,
    mobileNavActiveIndex: mobileNavActiveIndex,
    handleMobileNavToggleClick: handleMobileNavToggleClick,
    handleMobileNavDropdownClick: handleMobileNavDropdownClick
  };
}